export function copyRulesToClipboard(rules) {
  navigator.permissions.query({ name: "clipboard-write" }).then(result => {
    if (result.state === "granted" || result.state === "prompt") {
      const ruleString = rules.map(rule => rule.text).join("|");
      navigator.clipboard.writeText(ruleString).then(
        function() {
          return true;
        },
        function() {
          return false;
        }
      );
    } else {
      return false;
    }
  });
}
